let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e4h4P")).then(() => parcelRequire('6zDV7'));